<template>
    <div class="growthFile">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "growthFile",
    components: {
    },
    data() {
        return {

        }
    },
    methods: {
    },
}

</script>
<style scoped lang="less">
</style>